export type Preloader = {
  isShow: boolean
  requestQty: number
}

export const defaultPreloaderState: Preloader = {
  isShow: false,
  requestQty: 0
}
